
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 1.818a8.182 8.182 0 100 16.364 8.182 8.182 0 000-16.364zM0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10zm15.68 0a5.685 5.685 0 00-4.058-5.447l.39-1.307a7.048 7.048 0 010 13.507l-.39-1.307A5.685 5.685 0 0015.68 10zM8.375 4.553a5.685 5.685 0 000 10.893l-.39 1.307a7.048 7.048 0 010-13.507l.39 1.307zm3.03 1.892a2.464 2.464 0 00-.725-.362v-.626H9.316v.536a2.707 2.707 0 00-1.18.486 2.09 2.09 0 00-.863 1.707c0 .873.394 1.467.926 1.874.24.183.5.323.73.437.11.054.221.107.325.156l.02.01c.112.053.217.102.32.154.175.087.365.172.524.242l.173.078c.202.092.333.162.427.23.084.06.118.106.138.144.02.038.054.126.054.311 0 .086-.027.167-.167.261-.162.11-.43.194-.742.194a1.44 1.44 0 01-.701-.203c-.2-.124-.208-.214-.208-.252a.91.91 0 10-1.818 0c0 .872.534 1.464 1.061 1.793.304.19.645.323.981.4v.534h1.364v-.52c.38-.076.754-.219 1.08-.439.541-.365.968-.967.968-1.768 0-.419-.08-.804-.258-1.149a2.222 2.222 0 00-.686-.78 4.284 4.284 0 00-.738-.41c-.087-.04-.165-.075-.24-.107-.138-.062-.262-.117-.398-.185-.124-.062-.246-.12-.358-.173l-.014-.006a17.116 17.116 0 01-.298-.143 2.73 2.73 0 01-.436-.255.547.547 0 01-.161-.171.526.526 0 01-.05-.257c0-.108.036-.177.132-.249.118-.088.322-.161.566-.166.245-.004.436.063.54.14.076.056.127.123.127.275a.91.91 0 001.818 0c0-.757-.348-1.359-.869-1.74z"}})])
          )
        }
      }
    